// src/components/Modals/SaveReportModal.jsx
import React, { useState } from 'react';
import axios from 'axios';
import './ModalBase.css';
import { FaTimes } from 'react-icons/fa';
import API_BASE_URL from '../../config';

export default function SaveReportModal({ onClose }) {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate]     = useState('');

  const handleDownload = async () => {
    try {
      if (!startDate || !endDate) {
        // Можно, например, подсветить ошибку или показать alert, но оставим простую проверку
        alert('Пожалуйста, укажите обе даты.');
        return;
      }

      // Формируем параметры запроса. Если бэкенд ожидает формат ISO (YYYY-MM-DDThh:mm:ss),
      // можно дополнительно дозаказать время, но в большинстве случаев достаточно YYYY-MM-DD
      const params = new URLSearchParams({
        date_from: startDate, 
        date_to: endDate    
      });

      // Адрес вашего бэкенда и эндпоинта
      const url = `${API_BASE_URL}/breake_problem/export_breake_problems?${params.toString()}`;

      // Делаем GET с responseType = 'blob' для получения файла
      const response = await axios.get(url, {
        responseType: 'blob',
      });

      // Пытаемся вытянуть имя файла из заголовка Content-Disposition
      let fileName = 'report.xlsx';
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      // Создаем Blob и скачиваем файл
      const blob = new Blob([response.data], { type: response.data.type });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      
      // Закрываем модалку после скачивания
      onClose();

    } catch (error) {
      console.error('Ошибка при скачивании отчёта:', error);
      alert('Не удалось скачать отчёт. Попробуйте ещё раз или обратитесь к администратору.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-window-save">
        {/* Кнопка закрытия */}
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        {/* Заголовок */}
        <h2 className="modal-title">Сохранение отчёта</h2>

        {/* Описание */}
        <div className="modal-form">
          <p className="modal-delete-text">
            Для формирования отчёта необходимо указать даты начала и конца отчётного промежутка.
          </p>

          {/* Дата начала */}
          <label>Дата начала:</label>
          <input
            type="date"
            className="modal-input"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
          />

          {/* Дата конца */}
          <label>Дата конца:</label>
          <input
            type="date"
            className="modal-input"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
          />
        </div>

        {/* Действия */}
        <div className="modal-actions">
          <button className="modal-button cancel" onClick={onClose}>
            Отмена
          </button>
          <button className="modal-button save" onClick={handleDownload}>
            Скачать
          </button>
        </div>
      </div>
    </div>
  );
}
